<template>
  <div class="grid fx_ctr h__fixed scrollable pagebox">    
    <div class="listcon mcol h__fixed scroll__y menus">
      <h1 class="title spacing">Settings</h1>
      <McolMenu :menus="menus" />       
    </div>
    <div class="stage mcon h__fixed scroll__y page">
      <router-view/>
    </div>
  </div>
</template>

<script>
import McolMenu from '@/components/Common/McolMenu.vue';

export default {
  name: 'Settings',
  data() {
    return {
      menus: [
        {
          route: 'SettingsUpdate',
          label: 'Update'
        },
        {
          route: 'SettingsData',
          label: 'Data / Backup'
        },
        {
          route: 'SettingsCloud',
          label: 'Cloud'
        },
        {
          route: 'SettingsPrivacy',
          label: 'Privacy'
        },
        {
          route: 'SettingsAbout',
          label: 'About'
        }
      ]
    }
  },   
  components: {
    McolMenu
  }
}
</script>